import myAxios from "../utils/request";
export default {
  getHomepageNews(params) {
    const { num } = params;
    return myAxios.get(`/api/activity/gettopactivity?Top=${num}`);
  },
  getNewsList(params) {
    return myAxios.post("/api/activity/getfontactivitylist", params);
  },
  getNewsInfo(params) {
    const { Id } = params;
    return myAxios.get(`/api/activity/getfrontactivitybyid?AcID=${Id}`);
  }
};
